<template>
    <div class="mb-12 pt-10">
        <hr class="last_hr" color="#E6E6E6">
        <v-row>
            <v-col cols="4" class="mb-15 generateBtn" :class="{'generateBtn_disabled': !filled || loading}" @click.prevent="checkError">
              <img :src="head" class="head_img">
              <img :src="hand" class="hand_img">
                <v-btn
                x-large
                color="#ed6103"
                class="white--text main_btn bold"
                :loading="loading"
                :disabled="true"
                :class="{'loader': loading, 'disabled': !filled || loading}"
                >
                    ご報告画像を作成
                </v-btn>
                <div class="error_dialog_base">
                    <p class="ma-0 pa-0"
                    :class="{'d-none': !$store.state.error.server.notWork && !$store.state.error.server.timeout}"
                    style="font-size: 14px;">{{$store.state.error.server.timeout + $store.state.error.server.notWork}}</p>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {MAX_NAME, MAX_TITLE, MAX_CONTENT} from '../const';
import head from '../assets/head@2x.png';
import hand from '../assets/hand@2x.png';
export default {
    props:[
      'nameForm',
      'titleForm',
      'contentForm',
      'imgForm',
    ],
    data(){
        return{
            isValid: true,
            loading: false,
            errors: [],
            head,
            hand
        }
    },
    computed: {
        ...mapGetters(['checkTheme', 'filled']),
    },
    methods: {
        ...mapActions(['updateResponseAction', 'updateErrorAction', 'updateServerErrorAction', 'updateTimeoutErrorAction']),
        checkError(){
            this.loading = true;
            this.isValid = true;
            if ((this.nameForm.value.length === 0 || this.nameForm.value.length > MAX_NAME) ||
            (this.titleForm.value.length === 0 || this.titleForm.value.length > MAX_TITLE) ||
            (this.contentForm.value.length === 0 || this.contentForm.value.length > MAX_CONTENT) ||
            (this.checkTheme && this.imgForm.files.length !== 1)){
                this.isValid = false;
            }
        },
    }
}
</script>
<style scoped>
.generateBtn{
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.generateBtn_disabled{
  pointer-events: none;
}
@media all and (-ms-high-contrast: none) {
  .generateBtn{
    margin: 0 auto;
  }
}
.error_dialog_base{
  text-align: center;
    margin: 0 0 8px;
    padding: 0 12px;
    background-color: white;
    color: #FF5252;
    width: 80vw;
    z-index: 1;
    transform: translate(0px, 20px);
}
@-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
